'use client';

import React from 'react';
import Image from 'next/image';

const Footer = (props) => {
  const { dict } = props;

  return (
    <footer className='relative bg-black border-t border-white/10 py-12 px-4'>
      <div className='max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6'>
        {/* Logo */}
        <div className='flex items-center gap-3'>
          <Image
            src='/images/logo_mini.png'
            alt='Техніка і гаджети'
            width={48}
            height={48}
            className='invert'
          />
          <div className='flex flex-col leading-tight'>
            <span className='text-sm font-oswald font-semibold text-white tracking-wide uppercase'>
              Техніка і гаджети
            </span>
            <span className='text-[11px] font-montserrat text-gray-500 uppercase tracking-[0.18em]'>
              Distribution
            </span>
          </div>
        </div>

        {/* Copyright */}
        <p className='text-sm font-montserrat text-gray-400 text-center'>
          © {new Date().getFullYear()} Техніка і гаджети. {dict.copyright}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
